import { NumberInputOwnerState, NumberInputProps } from "@mui/base/Unstable_NumberInput";
import clsx from "clsx";

export const resolveSlotProps = (fn: any, args: any) => (typeof fn === "function" ? fn(args) : fn);

export const getRootStyles = (
    ownerState: NumberInputOwnerState,
    slotProps: NumberInputProps["slotProps"],
    fieldError?: boolean,
    disabled?: boolean,
) => {
    const resolvedSlotProps = resolveSlotProps(slotProps?.root, ownerState);
    return {
        ...resolvedSlotProps,
        className: clsx(
            "grid grid-cols-[1fr_8px] grid-rows-2 overflow-hidden font-sans rounded border border-solid bg-white hover:border-blue focus-visible:outline-0 p-[4.8px]",
            ownerState.focused ? "border-blue" : "border-gray-300",
            { "border-red hover:border-red": !!fieldError },
            { "bg-[#F7F7F4]": disabled },
            resolvedSlotProps?.className,
        ),
        style: {
            boxShadow:
                ownerState.focused && !fieldError ? `0px 0px 0px 3px var(--active-blue)` : "none",
        },
    };
};

export const getInputStyles = (
    ownerState: NumberInputOwnerState,
    slotProps: NumberInputProps["slotProps"],
) => {
    const resolvedSlotProps = resolveSlotProps(slotProps?.input, ownerState);
    return {
        ...resolvedSlotProps,
        className: clsx(
            "col-start-1 col-end-2 row-start-1 row-end-3 text-sm font-sans leading-normal text-black bg-inherit border-0 rounded-[inherit] px-3 py-2 outline-0 focus-visible:outline-0 focus-visible:outline-none",
            resolvedSlotProps?.className,
        ),
    };
};

export const getIncrementButtonStyles = (
    ownerState: NumberInputOwnerState,
    slotProps: NumberInputProps["slotProps"],
) => {
    const resolvedSlotProps = resolveSlotProps(slotProps?.incrementButton, ownerState);
    return {
        ...resolvedSlotProps,
        type: "button",
        children: "▴",
        className: clsx(
            "font-[system-ui] flex flex-row flex-nowrap justify-center items-center p-0 w-[19px] h-[19px] border border-solid outline-none text-sm box-border leading-[1.2] rounded-t-md border-slate-200 bg-slate-50 text-gray-500 transition-all duration-[120ms] cursor-pointer hover:text-blue col-start-3 col-end-3 row-start-1 row-end-2",
            resolvedSlotProps?.className,
        ),
    };
};

export const getDecrementButtonStyles = (
    ownerState: NumberInputOwnerState,
    slotProps: NumberInputProps["slotProps"],
) => {
    const resolvedSlotProps = resolveSlotProps(slotProps?.decrementButton, ownerState);
    return {
        ...resolvedSlotProps,
        type: "button",
        children: "▾",
        className: clsx(
            "font-[system-ui] flex flex-row flex-nowrap justify-center items-center p-0 w-[19px] h-[19px] border border-solid outline-none text-sm box-border leading-[1.2] rounded-b-md border-slate-200 border-t-0 bg-slate-50 text-gray-500 transition-all duration-[120ms] cursor-pointer hover:text-blue col-start-3 col-end-3 row-start-2 row-end-3",
            resolvedSlotProps?.className,
        ),
    };
};
